import { render, staticRenderFns } from "./CheckoutPaymentHeader.vue?vue&type=template&id=06baef89&scoped=true&"
import script from "./CheckoutPaymentHeader.vue?vue&type=script&lang=js&"
export * from "./CheckoutPaymentHeader.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutPaymentHeader.vue?vue&type=style&index=0&id=06baef89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06baef89",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
